import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';

export class CDAFilter extends BaseListFilter {
  search?: string;

  constructor(
    public sortBy: string = 'id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
